export default __webpack_public_path__ + "static/media/image-photography.104cf40b.jpg";